import { type ChannelId } from '@onr/schema'
import { useQuery } from '@tanstack/react-query'

import { useFirebaseUser } from '@/auth/useFirebaseUser'
import { userQuery } from '@/state/users/user'

import { channelEveningQuery } from './channel'

export const useChannelUnread = (regionId: string, channelId: ChannelId, eveningId: number | undefined): boolean => {
  const uid = useFirebaseUser()?.firebaseUser.uid
  const { data: channelEvening } = useQuery(channelEveningQuery(regionId, channelId, eveningId))
  const { data: user } = useQuery(userQuery(uid))

  const lastMessageAt = channelEvening?.data?.lastMessageAt
  if (eveningId === undefined || !lastMessageAt) {
    return false
  }
  if (channelEvening?.data?.lastMessageSenderId === uid) {
    return false
  }

  // The read cursor lives in users/{uid}: before that snapshot lands, an absent cursor means the
  // document is still loading, not that the thread is unread.
  if (!user) {
    return false
  }

  const preferences = user.data?.channels?.[channelId]
  if (preferences?.lastReadEveningId !== eveningId || !preferences.lastReadAt) {
    return true
  }
  return lastMessageAt > preferences.lastReadAt
}
